




























































































import { Ref, Component, Emit, Watch } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { DataTable } from '@/components/molecules/DataTable'
import {
  AlertMessage,
  defaultSystemCodeAddress,
  ErrorMessage,
  jobApi,
  SystemCodeAddress,
  systemCodeAddressApi
} from '@/api'
import {
  alertStore,
  dataStore,
  modalErrorStore,
  modalJobListStore
} from '@/store'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { CodeAddressTable } from '@/components/organisms/CodeAddressTable'
import { AtomTextField } from '@/components/atoms'
import { AddressCodeDialogInitialFocus } from '@/types'

interface FilterCondition {
  code: string
  areaCode: string
  zipCode: string
  name: string
}

const defaultFilterCondition = (): FilterCondition => ({
  code: '',
  name: '',
  areaCode: '',
  zipCode: ''
})

@Component({
  components: {
    CodeAddressTable,
    ModalFooter,
    DataTable
  }
})
export default class ModalCodeAddress extends ModalComponentBaseVue {
  @Ref()
  addressCodeTextField!: AtomTextField

  @Ref()
  areaCodeTextField!: AtomTextField

  @Ref()
  zipCodeTextField!: AtomTextField

  @Ref()
  nameTextField!: AtomTextField

  dialog: boolean = false

  tableBodyHeight: number = 0

  items: SystemCodeAddress[] = []

  selected: SystemCodeAddress = defaultSystemCodeAddress()

  filterCondition: FilterCondition = defaultFilterCondition()

  get codeMask(): string {
    return 'X'.repeat(6)
  }

  get zipCodeMask(): string {
    return '###-####'
  }

  get existsItems(): boolean {
    return this.filteredItems.length > 0
  }

  get filteredItems(): SystemCodeAddress[] {
    const codeRegExp = new RegExp(`^${this.filterCondition.code}`)
    const areaCodeRegExp = new RegExp(`^${this.filterCondition.areaCode}`)
    const zipCodeRegExp = new RegExp(`^${this.filterCondition.zipCode}`)
    const nameRegExp = new RegExp(`${this.filterCondition.name}`)

    return this.items.filter(
      item =>
        (this.filterCondition.code === '' || item.code.match(codeRegExp)) &&
        (this.filterCondition.areaCode === '' ||
          item.areaCode.code.match(areaCodeRegExp)) &&
        (this.filterCondition.zipCode === '' ||
          item.zipCode.match(zipCodeRegExp)) &&
        (this.filterCondition.name === '' || item.name.match(nameRegExp))
    )
  }

  @Watch('filteredItems')
  onFiltered(newVal: SystemCodeAddress[]): void {
    if (
      newVal.every(item => item.code !== this.selected.code) &&
      newVal.length > 0
    ) {
      this.selected = newVal[0]
    } else if (newVal.length === 0) {
      this.selected = defaultSystemCodeAddress()
    }
  }

  @Watch('dialog')
  onShowChanged(val: boolean) {
    if (val) {
      this.opened()
    } else {
      this.closed()
    }
  }

  mounted() {
    this.debug('mounted()')
    window.addEventListener('resize', this.onResize)
  }

  beforeDestroy() {
    this.debug('beforeDestroy()')
    window.removeEventListener('resize', this.onResize)
  }

  open(): void {
    this.dialog = true
    this.$nextTick(() => {
      this.calculateTableHeight()
      setTimeout(this.focus)
    })
  }

  close(): void {
    this.dialog = false
    this.filterCondition = defaultFilterCondition()
  }

  focus(): void {
    switch (dataStore.addressCodeDialogInitialFocus) {
      case AddressCodeDialogInitialFocus.AddressCode:
        this.addressCodeTextField.atomTextField.focus()
        break
      case AddressCodeDialogInitialFocus.AreaCode:
        this.areaCodeTextField.atomTextField.focus()
        break
      case AddressCodeDialogInitialFocus.ZipCode:
        this.zipCodeTextField.atomTextField.focus()
        break
      case AddressCodeDialogInitialFocus.AddressName:
        this.nameTextField.atomTextField.focus()
        break
      default:
        // デフォルトは住所コードとする
        this.addressCodeTextField.atomTextField.focus()
    }
  }

  async fetchAll() {
    try {
      this.items = await systemCodeAddressApi.getAllSystemCodeAddress()
      if (this.items.length > 0) {
        this.selected = this.items[0]
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onClickOk(): void {
    this.$emit('ok', this.selected)
    this.close()
  }

  onClickCancel(): void {
    this.$emit('cancel')
    this.close()
  }

  onClickPrint(): void {
    const element = document.querySelector<HTMLElement>(
      '.v-dialog--active #modal-code-address'
    )
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  onResize(): void {
    this.calculateTableHeight()
  }

  onRowClick(index: number): void {
    this.selected = this.filteredItems[index]
  }

  onRowDblclick(): void {
    this.onClickOk()
  }

  async downloadExcel() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const jobId = await jobApi.createSystemCodeAddressList()

      await modalJobListStore.newJobId(jobId)
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('opened')
  opened(): void {
    this.fetchAll()
  }

  @Emit('closed')
  closed(): void {
    this.items = []
  }
}
